'use strict';

module.exports = ['$uibModalInstance', 'BuilderDataService', 'element', function ($uibModalInstance, BuilderDataService, element) {
    var _this = this;
    _this.element = element;
    _this.form = BuilderDataService.getForm();

    this.validOperations = ["=", "!=", "<", ">", "<=", ">=", "existe", "!existe"];
    this.removeBlock = function (scope) {
        scope.remove();
    };

    this.removeCondition = function (index) {
        _this.element.templateData.dynamicOptions.splice(index, 1);
    };
    this.addCondition = function (conditions) {
        if (_this.element.templateData.dynamicOptions) {
            _this.element.templateData.dynamicOptions.push({
                conditions: [
                    {
                        type: "field",
                        fieldId: "",
                        value: "",
                        operator: "" //>,< ,>= >=, !=
                    }
                ],
                options: []
            });
        } else {
            _this.element.templateData.dynamicOptions = [
                {
                    conditions: [
                        {
                            type: "field",
                            fieldId: "",
                            value: "",
                            operator: "" //>,< ,>= >=, !=
                        }
                    ],
                    options: []
                }
            ];
        }
    };

    this.addBlock = function (operator, list) {
        switch (operator) {
            case "or":
                list.push({
                    type: "operator",
                    operator: "or",
                    rules: []
                });
                break;
            case "and":
                list.push({
                    type: "operator",
                    operator: "and",
                    rules: []
                });
                break;
            case "field":
                list.push({
                    type: "field",
                    fieldId: "",
                    value: "",
                    operator: "" //>,< ,>= >=, !=
                });
                break;
            default:
                break;
        }
    };

    this.areValid = function (conditions) {
        var invalid = conditions.filter(function (con) {
            return !con.valid;
        });

        if (invalid) {
            return false;
        } else {
            return true;
        }
    };

    this.close = function () {
        _this.$close(_this.element);
    };
}]